export default __webpack_public_path__ + "static/media/CSS & HTML.231e84d2.png";